import { render, staticRenderFns } from "./Repuestos.vue?vue&type=template&id=752bcb8c&"
import script from "./Repuestos.vue?vue&type=script&lang=js&"
export * from "./Repuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports